







import { Component, Prop, Vue } from "vue-property-decorator";
import { Section } from "@/types/section";
import SectionItem from "@/components/SectionItem.vue";

@Component({
  components: {
    SectionItem
  }
})
export default class SectionList extends Vue {
  @Prop({ type: Array, required: true }) private sections!: Section[];
}
